<page-header [section]="'auto-load-gateway-entries'">
  <page-title>Auto-Load Gateway Entries</page-title>
  <page-blurb
    >Manage gateway entries. Update or delete existing gateways. Create new
    gateway entries.</page-blurb
  >
</page-header>

<spinner *ngIf="!entries"></spinner>

<div *ngIf="entries" class="row">
  <div class="col-3 p-2" *ngFor="let entry of entries.items">
    <div class="card border-info" style="height: 85%" *ngIf="entry">
      <div class="card-header font-weight-bold bg-info text-white">
        {{ entry.identifier }}
      </div>
      <div class="card-body">
        <div class="form-group row">
          <strong class="col-5">Series:</strong>
          <div class="col-7">
            {{ entry.series }}
          </div>
        </div>
        <div class="form-group row">
          <strong class="col-5">Serial:</strong>
          <div class="col-7">
            {{ entry.serial }}
          </div>
        </div>
        <div class="form-group row">
          <strong class="col-5">Verification Code:</strong>
          <div class="col-7">
            {{ entry.verification_code }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
